import { useCallback, useState } from 'react';
import { FileRejection, useDropzone } from 'react-dropzone';
import { FileUploadMode } from '@sib/types';
import { useDialogStore } from '@spendbrain/common/stores';
import { useFileManagerFileUploadStore } from '@spendbrain/stores/fileUploadStore';
import { DROPZONE_CONFIG, useOnDropHandler } from '@spendbrain/utils/files';

export const useFileDropDialog = () => {
  const [, setDragCount] = useState(0);
  // ToDO refactor counter
  const [currentMode, setCurrentMode] = useState<FileUploadMode | null>(null);
  const { addFiles } = useFileManagerFileUploadStore();
  const { onDrop: handleFileDrop } = useOnDropHandler({ addFiles });
  const { opened: isOpen } = useDialogStore();
  // Todo
  const onDragEnter = (event: React.DragEvent) => {
    event.preventDefault();

    if (currentMode === FileUploadMode.FileManager || !!isOpen) return;

    setDragCount(prev => {
      const newCount = prev + 1;
      if (newCount === 1) {
        setCurrentMode(FileUploadMode.Dropzone);
      }

      return newCount;
    });
  };

  const onDragLeave = (event: React.DragEvent) => {
    event.preventDefault();

    setDragCount(prev => {
      const newCount = prev - 1;
      if (newCount === 0) {
        setCurrentMode(null);
      }

      return newCount;
    });
  };
  const onDrop = useCallback(
    (acceptedFiles: File[], fileRejections: FileRejection[]) => {
      if (currentMode === FileUploadMode.FileManager || isOpen) return;
      handleFileDrop(acceptedFiles, fileRejections);
      setDragCount(0);
      setCurrentMode(FileUploadMode.FileManager);
    },
    [handleFileDrop, currentMode, isOpen]
  );
  const { getRootProps, getInputProps } = useDropzone({
    ...DROPZONE_CONFIG,
    onDrop,
    noClick: true,
    noKeyboard: true,
    onDragEnter,
    onDragLeave,
  });

  const closeDialog = () => {
    setCurrentMode(null);
    setDragCount(0);
  };

  const openDialog = (mode?: FileUploadMode) =>
    setCurrentMode(mode || FileUploadMode.Dropzone);

  return {
    getRootProps,
    getInputProps,
    closeDialog,
    currentMode,
    openDialog,
    onModeChange: setCurrentMode,
  };
};
